import { render } from "./CoBrandThemeClassic.vue?vue&type=template&id=6e2a88e1&scoped=true"
import script from "./CoBrandThemeClassic.vue?vue&type=script&lang=js"
export * from "./CoBrandThemeClassic.vue?vue&type=script&lang=js"

import "./CoBrandThemeClassic.vue?vue&type=style&index=0&id=6e2a88e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2a88e1"]])

export default __exports__